export const RBAC = {
  activate_process: "activate_process",
  activate_service: "activate_service",
  add_clients_to_groups: "add_clients_to_groups",
  add_contacts: "add_contacts",
  add_documents: "add_documents",
  add_notes: "add_notes",
  add_payment_details: "add_payment_details",
  answer_questions: "answer_questions",
  assign_tags_to_case: "assign_tags_to_case",
  assign_user_to_case: "assign_user_to_case",
  assign_user_to_step: "assign_user_to_step",
  close_case: "close_case",
  confirm_case: "confirm_case",
  create_case: "create_case",
  create_categories: "create_categories",
  create_client: "create_client",
  create_document_types: "create_document_types",
  create_groups: "create_groups",
  create_process: "create_process",
  create_questions: "create_questions",
  create_roles: "create_roles",
  create_tags: "create_tags",
  create_users: "create_users",
  delete_case: "delete_case",
  explorer: "explorer",
  roles: "roles",
  search: "search",
  send_broadcast_to_groups: "send_broadcast_to_groups",
  send_invites: "send_invites",
  send_messages: "send_messages",
  send_notice_to_clients: "send_notice_to_clients",
  service_explorer: "service_explorer",
  manage_case_workflow: "manage_case_workflow",
  switch_process: "switch_process",
  switch_step: "switch_step",
  tags: "tags",
  update_contact_details: "update_contact_details",
  view_case_details: "view_case_details",
  view_client_cases: "view_client_cases",
  view_client_details: "view_client_details",
  view_clients: "view_clients",
} as const;

export type RbacPermissionKey = (typeof RBAC)[keyof typeof RBAC];
